<template>
    <input
        v-model="model"
        class="input"
        name="partner-name"
    />
</template>

<script setup lang="ts">
const model = defineModel<string>({ required: true })
</script>

<style scoped>
/* Important! Do not use 'honeypot' as class name, may alert bots */
.input {
    display: none;
}
</style>
